/**
 * **Makeready Hotels/Selfbook**
 *
 * @exports partnership_10029
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    let hotelIdByParam;
    /**
         * @memberOf module:partnership_10029
         */
    partnership.getId = function getId() {
        return '10029';
    };
    /**
         * @memberOf module:partnership_10029
         */
    partnership.check = function check() {
        // Get the URL of the button link, if it exists
        const buttonElement = document.querySelector('.book-now a');
        const urlButton = buttonElement?.href && new URL(buttonElement.href);
        // Get the URL of the script, if it exists
        const scriptElement = document.querySelector('#selfbook_jssdk');
        const urlScript = scriptElement?.src && new URL(scriptElement.src);
        // Get the hotel ID from the parameters of the button URL or the script URL
        // If the 'hotel' parameter exists in the button URL search, it will be assigned to 'hotelIdByParam'
        // Otherwise, 'hotelId' will be searched in the script URL search and assigned to 'hotelIdByParam'
        hotelIdByParam = thn.parseUrlParameter('hotel', urlButton?.search) || thn.parseUrlParameter('hotelId', urlScript?.search);
        return !!hotelIdByParam;
    };
    /**
         * @memberOf module:partnership_10029
         */
    partnership.getHotelId = function getHotelId() {
        // This chain has two BE's, one for desktop and one for mobile, so it has different properties for each version.
        const result = {
            partnership_hotel_id: thn.data.media.name === 'mobile' ? `${hotelIdByParam}-m` : `${hotelIdByParam}-d`,
        };
        return result;
    };
    return partnership;
}

export { factory };
